
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.726 4.493L4.718 3.12a.219.219 0 00-.295-.055c-1.319.854-1.681 2.157-1.152 3.118.578 1.05 1.47 2.34 2.84 3.708 1.368 1.368 2.656 2.26 3.707 2.84.961.528 2.264.166 3.118-1.153a.219.219 0 00-.055-.295l-1.374-1.008a.669.669 0 00-.694-.059l-.548.274a1.885 1.885 0 01-1.71.004c-.404-.208-1.027-.603-1.736-1.312-.709-.71-1.104-1.332-1.312-1.736a1.885 1.885 0 01.004-1.71l.274-.548a.669.669 0 00-.06-.694zm-2.03-2.551C1.998 3.04 1.124 5.055 2.1 6.827c.637 1.156 1.604 2.547 3.066 4.008 1.461 1.462 2.852 2.429 4.008 3.066 1.772.975 3.786.101 4.885-1.597a1.556 1.556 0 00-.386-2.1l-1.375-1.008a2.006 2.006 0 00-2.082-.177l-.548.274a.55.55 0 01-.5.011c-.287-.148-.796-.462-1.402-1.069-.607-.606-.921-1.115-1.069-1.402a.55.55 0 01.01-.5l.275-.548a2.006 2.006 0 00-.177-2.083L5.796 2.328a1.556 1.556 0 00-2.1-.386z","fill":"currentColor"}})])
          )
        }
      }
    